export default {
  header: "Welcome to Risk Radar",
  view: "Home"
};
